import { AxiosResponse } from 'axios';
import { SET_MINYANIMS, SET_MINYANIM, SET_ERRORMSG } from '@/store/mutation_types';
import {
  CLEAR_MINYANIM_ISLOADING,
  DELETE_MINYANIM,
  EDIT_MINYANIM,
  GET_MINYANIMS,
  REGISTER_MINYANIM,
  SYNC_MINYANIM,
} from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import Minyanim from '@/services/minyanim';
import { Module } from 'vuex';
import { EditMinyanim, RegisterMinyanim, GetMinyanim } from '@/dtos/minyanim.dto';

const minyanim: Module<any, {}> = {
  state: {
    minyanim: {
      data: null,
      isLoading: false,
    },
    minyanims: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    minyanim: (state: { minyanim: any }) => state.minyanim,
    minyanims: (state: { minyanims: any }) => state.minyanims,
  },
  mutations: {
    [SET_MINYANIM]: (
      state: { minyanim: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.minyanim.data = payload.data) : null,
        (state.minyanim.isLoading = payload.isLoading);
    },
    [SET_MINYANIMS]: (
      state: { minyanims: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.minyanims.data = payload.data) : null,
        (state.minyanims.isLoading = payload.isLoading);
    },
  },
  actions: {
    [REGISTER_MINYANIM]: async ({ commit }: any, payload: any) => {
      commit(SET_MINYANIM, { data: null, isLoading: true });

      const result: AxiosResponse = await Minyanim.registerMinyanim(
        payload as RegisterMinyanim
      );

      if (result) {
        if (result.data.status) {
          commit(SET_MINYANIM, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_MINYANIM, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_MINYANIM, { isLoading: false });
        return false;
      }
    },
    [GET_MINYANIMS]: async ({ commit }: any, payload: any) => {
      commit(SET_MINYANIMS, { data: null, isLoading: true });

      const result: AxiosResponse = await Minyanim.getMinyanims(
        payload as GetMinyanim
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_MINYANIMS, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_MINYANIMS, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_MINYANIMS, { isLoading: false });
        return false;
      }
    },
    [EDIT_MINYANIM]: async ({ commit }: any, payload: any) => {
      commit(SET_MINYANIM, { data: null, isLoading: true });

      const result: AxiosResponse = await Minyanim.editMinyanim(
        payload as EditMinyanim
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_MINYANIM, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_MINYANIM, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_MINYANIM, { isLoading: false });
        return false;
      }
    },
    [SYNC_MINYANIM]: async ({ commit }: any, payload: any) => {
      commit(SET_MINYANIM, { data: null, isLoading: true });

      const result: AxiosResponse = await Minyanim.syncMinyanim(
        payload as EditMinyanim
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_MINYANIM, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_MINYANIM, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_MINYANIM, { isLoading: false });
        return false;
      }
    },
    [DELETE_MINYANIM]: async ({ commit }: any, payload: string) => {
      commit(SET_MINYANIM, { data: null, isLoading: true });

      const result: AxiosResponse = await Minyanim.deleteMinyanim(payload);

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_MINYANIM, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_MINYANIM, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_MINYANIM, { isLoading: false });
        return false;
      }
    },
    [CLEAR_MINYANIM_ISLOADING]: ({ commit }) => {
      commit(SET_MINYANIM, { isLoading: false });
      commit(SET_MINYANIMS, { isLoading: false });
    },
  },
};

export default minyanim;
